export default "__VITE_ASSET__D1GVtUgM__"